import {
    forwardRef,
    InputHTMLAttributes,
    useEffect,
    useImperativeHandle,
    useRef,
} from "react";

export default forwardRef(function TextArea(
    {
        className = "",
        isFocused = false,
        disabled = false,
        ...props
    }: InputHTMLAttributes<HTMLTextAreaElement> & { isFocused?: boolean },
    ref,
) {
    const localRef = useRef<HTMLTextAreaElement>(null);

    useImperativeHandle(ref, () => ({
        focus: () => localRef.current?.focus(),
    }));

    useEffect(() => {
        if (isFocused) {
            localRef.current?.focus();
        }
    }, [isFocused]);

    return (
        <textarea
            rows={4}
            {...props}
            disabled={disabled}
            className={
                "rounded-md border-gray-300 shadow-sm focus:border-neutral4 focus:ring-neutral4 ring-neutral4 " +
                className
            }
            ref={localRef}
        />
    );
});
